import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IDiagnosticChatEntry {
  conversationId: string;
}

const diagnosticChatSlice = createSlice({
  name: "diagnosticChatSlice",
  initialState: {} as Record<string, IDiagnosticChatEntry>,
  reducers: {
    saveDiagnosticChat: (
      state,
      action: PayloadAction<{
        diagnosticId: string;
        entry: IDiagnosticChatEntry;
      }>,
    ) => {
      state[action.payload.diagnosticId] = action.payload.entry;
    },
  },
});

export const { saveDiagnosticChat } = diagnosticChatSlice.actions;
export default diagnosticChatSlice.reducer;
